import React, { useContext, useState, useEffect } from "react";
import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListRoundedIcon from "@material-ui/icons/ListRounded";
import { useHistory } from "react-router-dom";
import { useStyles } from "./style";
import { Context } from "../../store/Context";
import Icon from "../../assets/images/Icon.png";
import CaptisLogo from "../../assets/images/Captis.png";
import Snackbar from "@material-ui/core/Snackbar";
import { privateLogout, checkDomainIsCaptis } from "../../utils/Index";
import IconDashboard from '@material-ui/icons/Dashboard'
import IconShoppingCart from '@material-ui/icons/ShoppingCart'
import IconPeople from '@material-ui/icons/People'
import Creditcard from '@material-ui/icons/CreditCard'
import IconExpandLess from '@material-ui/icons/ExpandLess'
import IconExpandMore from '@material-ui/icons/ExpandMore'
import Collapse from '@material-ui/core/Collapse'
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AttachMoney from '@material-ui/icons/AttachMoney';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import GroupsIcon from '@material-ui/icons/Group';
import LayersIcon from '@material-ui/icons/Layers';
import StoreIcon from "@material-ui/icons/Store";
import AssignmentIcon from '@material-ui/icons/Assignment';
import ReceiptIcon from '@material-ui/icons/Receipt';
import BusinessIcon from '@material-ui/icons/Business';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import EventIcon from '@material-ui/icons/Event';
import RefreshIcon from '@material-ui/icons/Refresh';
import LinkIcon from '@material-ui/icons/Link';
import { getTenantInfoForAllUsers } from "../../services/myorganisationApis";
import ConfirmDialog from "../modals/ConfirmationModal";
import { useLocation } from "react-router-dom";
import NAVIGATION_PATH from "../../constants/navigationConstant";
import { ROUTES } from "../../constants/routeConstant";
import { NearMe } from "@material-ui/icons";
import { TenantTypes } from "../../constants/paymentProfileConstant";

const {
  ORDERS,
  MY_ORGANIZATION,
  USERS,
  PAYMENT_PROFILE,
  LOCATION,
  USER_ASSIGNMENT,
  TAKE_PAYMENT,
  DASHBOARD,
  INVENTORY_DASHBOARD,
  TRANSACTION,
  CASHLESS_PAYMENTS,
  CASH_PAYMENTS,
  FB_PAYMENTS,
  MEMBER_PAYMENTS,
  TRANSACTION_ITEMS,
  FUNDRAISER_EVENTS,
  FUNDRAISER_USERS,
  DEVICE_REBOOT,
  LINK_PAY,
} = NAVIGATION_PATH;

const { TRANSACTION_ITEM_SUMMARY } = ROUTES,
  currentRole = localStorage.getItem("superuser");

export default function TemporaryDrawer() {
  const [state, dispatch] = useContext(Context);
  const history = useHistory();
  const classes = useStyles();
  const [leftState, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const snackState = {
    vertical: "top",
    horizontal: "center",
  };
  const [snackMsg, setSnackMsg] = useState("");
  const [snackbar, setSnackbar] = useState(false);
  const { vertical, horizontal } = snackState;
  const handleSnackClose = () => {
    setSnackbar(false)
  };

  const location = useLocation();

  const isActive = path => {
    // Check if the current path matches the sidebar link
    return location.pathname === path ? classes.activeLink : "";
  };


  const [dialogConfig, setDialogConfig] = useState({
    dialogOpen: false,
    actionTitle: "",
    actionDescription: "",
    onCancel: () => {},
    onConfirm: () => {},
  });

  //set the configuration of confirmation dialog
  const handleConfirmationDialogConfig = ({
    actionTitle = "",
    actionDescription,
    onConfirm,
    onCancel,
    dialogOpen,
  }) => {
    setDialogConfig({
      ...dialogConfig,
      actionTitle,
      actionDescription,
      onConfirm,
      onCancel,
      dialogOpen,
    });
  };

  //set the visibility of confirmation dialog
  const handleConfirmationDialogVisibility = value => {
    setDialogConfig({
      ...dialogConfig,
      dialogOpen: value,
    });
  };

  useEffect(() => {
    if(localStorage.getItem('subDomain') && localStorage.getItem('token')) {
      getTenantInfoForAllUsers(`from-pwa=true`).then((tenant) => {
        const data = tenant?.data?.data?.results[0]
        const newDataSource = tenant?.data?.data?.results?.map((temp) =>{
          temp["icon"] = temp.logo
          temp["logo"] = <img alt="img" src={temp.logo} />;
          temp["Icon"] = temp?.logo ?? "";
          return temp;
          });
        dispatch({ type: "MY_ORGANIZATIONS", payload: newDataSource })
      })
    }
  },[dispatch])

  const siderButton = (text,anchor,open) => {
    if (localStorage.getItem("token")?.length === 0) {
      setSnackbar(true)
      setSnackMsg(`Cannot redirect to ${text}`);
    } else if (text === "Log Out") {
        caches.keys().then((keyList) => Promise.all(keyList.map((key) => caches.delete(key))))
        localStorage.clear();
        privateLogout();
        window.location.reload();
    } else {
      history.push(text);
    }
    setState({ ...leftState, [anchor]: open });
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...leftState, [anchor]: open });
  };

  const [opens, setOpens] = React.useState(false)

  const  handleClick = () => {
    setOpens(!opens)
  }

  const [fundraiserOpens, setFundraiserOpens] = React.useState(false)

  const  handleFundraiserClick = () => {
    setFundraiserOpens(!fundraiserOpens)
  }

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <div className={classes.logo}>
          <img src={ checkDomainIsCaptis() ? CaptisLogo : Icon} alt="icon" />
        </div>
        <Divider />
        <ListItem
          button
          className={`${classes.listItem} ${isActive(ORDERS)}`}
          onClick={() => siderButton(ORDERS, anchor, false)}
          onMouseOver={() => import("../order/Order")}
        >
          <ListItemIcon className={classes.listItemIcon}>
            <IconShoppingCart />
          </ListItemIcon>
          <ListItemText primary="Order" />
        </ListItem>
        {currentRole === "admin" && (
          <><ListItem
            button
            className={`${classes.listItem} ${isActive(MY_ORGANIZATION)}`}
            onClick={() => siderButton(MY_ORGANIZATION, anchor, false)}
            onMouseOver={() => import("../organisation/MyOrganisation")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <BusinessIcon />
            </ListItemIcon>
            <ListItemText primary="My Organization" />
          </ListItem><ListItem
            button
            className={`${classes.listItem} ${isActive(USERS)}`}
            onClick={() => siderButton(USERS, anchor, false)}
            onMouseOver={() => import("../users/Users")}
          >
              <ListItemIcon className={classes.listItemIcon}>
                <IconPeople />
              </ListItemIcon>
              <ListItemText primary="Users" />
            </ListItem><ListItem
              button
              className={`${classes.listItem} ${isActive(USER_ASSIGNMENT)}`}
              onClick={() => siderButton(USER_ASSIGNMENT, anchor, false)}
              onMouseOver={() => import("../profile/UserAssignment")}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <AssignmentIcon />
              </ListItemIcon>
              <ListItemText primary="User Assignment" />
            </ListItem></>
        )}

        <ListItem
          button
          className={`${classes.listItem} ${isActive(PAYMENT_PROFILE)}`}
          onClick={() => siderButton(PAYMENT_PROFILE, anchor, false)} onMouseOver={() => import("../profile/PaymentProfiles")}
        >
        <ListItemIcon className={classes.listItemIcon}>
          <ReceiptIcon />
        </ListItemIcon>
        <ListItemText primary="Payment Profiles" />
      </ListItem>

      {state.myOrganizations?.[0]?.type?.includes(TenantTypes.GC_MARKET) && <ListItem
        button
        className={`${classes.listItem} ${isActive(LOCATION)}`}
        onClick={() => siderButton(LOCATION, anchor, false)} 
        onMouseOver={() => import("../location/Location")}
      >
        <ListItemIcon className={classes.listItemIcon}>
          <NearMe />
        </ListItemIcon>
        <ListItemText primary="Location" />
      </ListItem>}

      {state.myOrganizations?.[0]?.type?.includes(TenantTypes.LINK_PAY) && <ListItem
        button
        className={`${classes.listItem} ${isActive(LINK_PAY)}`}
        onClick={() => siderButton(LINK_PAY, anchor, false)} 
        onMouseOver={() => import("../linkPay/LinkPay")}
      >
        <ListItemIcon className={classes.listItemIcon}>
          <LinkIcon />
        </ListItemIcon>
        <ListItemText primary="LinkPay" />
      </ListItem>}

      <ListItem
        button
        className={`${classes.listItem} ${isActive(DEVICE_REBOOT)}`} onClick={() => siderButton(DEVICE_REBOOT, anchor, false)} onMouseOver={() => import("../deviceReboot/DeviceReboot")}
      >
        <ListItemIcon className={classes.listItemIcon}>
          <RefreshIcon />
        </ListItemIcon>
        <ListItemText primary="Device Reboot" />
      </ListItem>

      <ListItem 
        button
        className={`${classes.listItem} ${isActive(TAKE_PAYMENT)}`} onClick={() => siderButton(TAKE_PAYMENT, anchor, false)} onMouseOver={() => import("../takePayment/takePayment")}
      >
          <ListItemIcon className={classes.listItemIcon}>
            <AttachMoney />
          </ListItemIcon>
          <ListItemText primary="Take Payment" />
        </ListItem>

      <ListItem button onClick={handleClick} className={classes.listItem}>
        <ListItemIcon className={classes.listItemIcon}>
          <SyncAltIcon />
        </ListItemIcon>
        <ListItemText primary="Transactions" />
        {opens ? <IconExpandLess style={{marginLeft: "100px", marginRight: "100%"}}/> : <IconExpandMore style={{marginLeft: "100px", marginRight: "100%"}}/>}
      </ListItem>

      <Collapse in={opens} timeout="auto" unmountOnExit>
        <Divider />
        <List component="div" disablePadding style={{backgroundColor: "aliceblue"}}>
          <ListItem
            button
            className={`${classes.listItem} ${isActive(DASHBOARD)}`} onClick={() => siderButton(DASHBOARD, anchor, false)} onMouseOver={() => import("../Transaction/Dashboard")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <IconDashboard />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
          <ListItem
            button
            className={`${classes.listItem} ${isActive(INVENTORY_DASHBOARD)}`}
            onClick={() => siderButton(INVENTORY_DASHBOARD, anchor, false)}
            onMouseOver={() => import("../inventoryDashboard/inventoryDashboard")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <StoreIcon />
            </ListItemIcon>
            <ListItemText primary="Inventory Dashboard" />
          </ListItem>
          <ListItem
            button
            className={`${classes.listItem} ${isActive(TRANSACTION)}`}
            onClick={() => siderButton(TRANSACTION, anchor, false)} onMouseOver={() => import("../Transaction/transaction")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <DoneAllIcon />
            </ListItemIcon>
            <ListItemText primary="All Transactions" />
          </ListItem>
          <ListItem
            button
            className={`${classes.listItem} ${isActive(CASHLESS_PAYMENTS)}`}
            onClick={() => siderButton(CASHLESS_PAYMENTS, anchor, false)}
            onMouseOver={() => import("../payments/CardPayments")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <Creditcard />
            </ListItemIcon>
            <ListItemText primary="Card Payments" />
          </ListItem>
          <ListItem
            button
            className={`${classes.listItem} ${isActive(CASH_PAYMENTS)}`}
            onClick={() => siderButton(CASH_PAYMENTS, anchor, false)}
            onMouseOver={() => import("../payments/CashPayments")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <LocalAtmIcon />
            </ListItemIcon>
            <ListItemText primary="Other Payments" />
          </ListItem>
          <ListItem
            button
            className={`${classes.listItem} ${isActive(FB_PAYMENTS)}`}
            onClick={() => siderButton(FB_PAYMENTS, anchor, false)}
            onMouseOver={() => import("../payments/FbPayments")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <LocalAtmIcon />
            </ListItemIcon>
            <ListItemText primary="FB Payments" />
          </ListItem>
          <ListItem
            button
            className={`${classes.listItem} ${isActive(MEMBER_PAYMENTS)}`}
            onClick={() => siderButton(MEMBER_PAYMENTS, anchor, false)}
            onMouseOver={() => import("../payments/MemberPayment")}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <GroupsIcon />
            </ListItemIcon>
            <ListItemText primary="Member/Room Payments" />
          </ListItem>
          <ListItem
            button
            className={`${classes.listItem} ${isActive(TRANSACTION_ITEMS)}`}
            onClick={() => siderButton(TRANSACTION_ITEMS, anchor, false)} onMouseOver={() => import("../Transaction/TransactionItems")}>
            <ListItemIcon className={classes.listItemIcon}>
              <LayersIcon />
            </ListItemIcon>
            <ListItemText primary={TRANSACTION_ITEM_SUMMARY} />
          </ListItem>
        </List>
        <Divider />
      </Collapse>
      
      {state.myOrganizations?.[0]?.type?.includes(TenantTypes.PATRON_GIVE) && currentRole === "admin" && <>
        <ListItem button onClick={handleFundraiserClick} className={classes.listItem}>
          <ListItemIcon className={classes.listItemIcon}>
            <MonetizationOnIcon />
          </ListItemIcon>
          <ListItemText primary="FundRaiser" />
          {fundraiserOpens ? <IconExpandLess style={{marginLeft: "100px", marginRight: "100%"}}/> : <IconExpandMore style={{marginLeft: "100px", marginRight: "100%"}}/>}
        </ListItem>

        <Collapse in={fundraiserOpens} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" disablePadding style={{backgroundColor: "aliceblue"}}>
            <ListItem
              button
              className={`${classes.listItem} ${isActive(FUNDRAISER_EVENTS)}`}
              onClick={() => siderButton(FUNDRAISER_EVENTS, anchor, false)}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <EventIcon />
              </ListItemIcon>
              <ListItemText primary="Events" />
            </ListItem>
            <ListItem
              button
              className={`${classes.listItem} ${isActive(FUNDRAISER_USERS)}`}
              onClick={() => siderButton(FUNDRAISER_USERS, anchor, false)}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <IconPeople />
              </ListItemIcon>
              <ListItemText primary="Users" />
            </ListItem>
          </List>
          <Divider />
        </Collapse>
      </>}

      <ListItem
        button
        className={classes.listItem}
        onClick={() => {
          handleConfirmationDialogConfig({
            actionDescription: "Do you want to Logout ?",
            actionTitle: "Logout",
            type: "confirm",
            onConfirm: () => siderButton("Log Out", anchor, false),
            onCancel: () => handleConfirmationDialogVisibility(false),
            dialogOpen: true,
          });
        }}
      >
        <ListItemIcon className={classes.listItemIcon}>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary="Log Out" />
      </ListItem>
      </List>
    </div>
  );

  return (
    <>
      <ConfirmDialog
        open={dialogConfig.dialogOpen}
        actionTitle={dialogConfig.actionTitle}
        actionDescription={dialogConfig.actionDescription}
        type="confirm"
        onCancel={dialogConfig.onCancel}
        onConfirm={dialogConfig.onConfirm}
      />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={snackbar}
        onClose={handleSnackClose}
        message={snackMsg}
        key={vertical + horizontal}
      />
      {["left"].map((anchor) => (
        <React.Fragment key={anchor}>
           <Button onClick={toggleDrawer(anchor, true)} className="pBtn pBtn--navToggle">
            <ListRoundedIcon fontSize="large" color="inherit" />
          </Button>
          <Drawer
            anchor={anchor}
            open={leftState[anchor]}
            onClose={toggleDrawer(anchor, false)}
            PaperProps={{
              style: {
                  width: 275,
              },
            }}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </>
  );
}
